import { TechDocPage, TechDocChecklistPage, TechDocWizardPage } from '../containers/pages';
import { gettingStarted } from './nimblePrimeraPageConfigComm';
import {
  DHCI_RACK_VIDEO,
  // DHCI_CABLE_VIDEO,
  DHCI_CABLE_STEP1_VIDEO,
  DHCI_CABLE_STEP2_VIDEO,
  DHCI_CABLE_STEP3_VIDEO,
  DHCI_SWITCH_CONFIGURE_VIDEO,
  DHCI_CABLE_STEP1_BROWN_VIDEO,
  DHCI_CABLE_STEP2_BROWN_VIDEO,
  DHCI_CABLE_STEP3_BROWN_VIDEO,
  DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
  UNBOX_VIDEO,
  // CABLES_VIDEO,
  RACK_STEP1_VIDEO,
  RACK_STEP2_VIDEO,
  RACK_STEP3_VIDEO,
  POWER_VIDEO,
} from '../constants';

// function configVcenterPageEvents() {
//   function selectorChangeHandler(evt) {
//     const eventTarget = evt.target;
//     if (eventTarget.id === 'config-vcenter-page-doc-selection') {
//       const newEnvDocElem = document.getElementById('config-vcenter-page-new-env-doc');
//       const existEnvDocElem = document.getElementById('config-vcenter-page-existing-env-doc');
//       if (eventTarget.value === 'new') {
//         newEnvDocElem.style.display = 'block';
//         existEnvDocElem.style.display = 'none';
//       } else {
//         newEnvDocElem.style.display = 'none';
//         existEnvDocElem.style.display = 'block';
//       }
//     }
//   }
//   window.addEventListener('change', selectorChangeHandler);
//   return () => {
//     window.removeEventListener('change', selectorChangeHandler);
//   };
// }

export const pagesConfig = [
  ...gettingStarted(),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: UNBOX_VIDEO,
        },
      },
      {
        path: '/physical-install/rackArray',
        menuText: 'rackArray',
        exact: true,
        redirectTo: '/physical-install/rackArray/1',
      },
      {
        path: '/physical-install/rackArray/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rackArray',
        pageProps: {
          steps: [
            {
              videoUrl: RACK_STEP1_VIDEO,
            },
            {
              videoUrl: RACK_STEP2_VIDEO,
            },
            {
              videoUrl: RACK_STEP3_VIDEO,
            },
          ],
        },
      },
      {
        path: '/physical-install/rackServersSwitches',
        menuText: 'rackServersSwitches',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: DHCI_RACK_VIDEO,
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        redirectTo: '/physical-install/cable/1',
      },
      {
        path: '/physical-install/cable/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl_green: DHCI_CABLE_STEP1_VIDEO,
              videoUrl_brown: DHCI_CABLE_STEP1_BROWN_VIDEO,
            },
            {
              videoUrl_green: DHCI_CABLE_STEP2_VIDEO,
              videoUrl_brown: DHCI_CABLE_STEP2_BROWN_VIDEO,
            },
            {
              videoUrl_green: DHCI_CABLE_STEP3_VIDEO,
              videoUrl_brown: DHCI_CABLE_STEP3_BROWN_VIDEO,
            },
          ],
        },
      },
      {
        path: '/physical-install/powerOn',
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: POWER_VIDEO,
        },
      },
    ],
  },
  {
    path: '/software-config',
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: '/software-config/configSwitch',
    submenuItems: [
      {
        path: '/software-config/configSwitch',
        menuText: 'configSwitch',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl_green: DHCI_SWITCH_CONFIGURE_VIDEO,
          videoUrl_brown: DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
        },
      },
      {
        path: '/software-config/prepareEnv',
        menuText: 'prepareEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arrayDiscovery',
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arraySetup',
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          // contentType: 'react-showdown',
        },
      },
      {
        path: '/software-config/configVCenter',
        menuText: 'configVCenter',
        exact: true,
        component: TechDocPage,
        // pageProps: {
        //   func: configVcenterPageEvents,
        // },
      },
      {
        path: '/software-config/connectArray',
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/addAndAssignArray',
        menuText: 'addAndAssignArray',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/validation',
        menuText: 'arrayValidation',
        exact: true,
        component: TechDocChecklistPage,
        pageProps: {},
      },

      {
        path: '/software-config/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
